import React from "react"
import styled, { keyframes } from "styled-components"
import Row from "../../styles/Row"

const pulse = keyframes`
  0% {
    opacity: 0;
    transform: rotate(17deg) scale(0.5);
  }
  100% {
    opacity: 1;
    transform: rotate(-5deg) scale(1);
  }
`

const BannerWrapper = styled.div`
  position: relative;
  z-index: 200;

  background-color: #d41773;
  color: #fff;

  transition: background 0.2s ease-in-out;

  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #d41773;
  }
`
BannerWrapper.row = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem 1rem 0.325rem;
  text-align: center;

  font-family: ${props => props.theme.font.heading};
  font-size: 1.1rem;

  media (max-width: 640px) {
    font-size: 1rem;
  }

  media (max-width: 480px) {
    font-size: 0.9rem;
  }

  strong {
    display: inline-block;
    margin-right: 0.625em;

    opacity: 0;
    font-weight: normal;

    animation: ${pulse} 0.7s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    animation-delay: 0.6s;
  }

  span {
    text-decoration: none;
    font-weight: bold;
  }
`

export default function NewFlavorsBanner(props) {
  return (
    <BannerWrapper>
      <BannerWrapper.row>
        <div>
          <strong>Limited Time!</strong>{" "}
          <span>Try our NEW Golden Oreo® Birthday Cake Milkshake!</span>
        </div>
      </BannerWrapper.row>
    </BannerWrapper>
  )
}
